export default __webpack_public_path__ + "static/media/vocal1.bf10ebb4.wav";